import { VectorGraphParam, ParamType } from "./enums";

export const degToRad = (angle: number) => angle * Math.PI / 180;

export class GraphSingle {
    #name = "";
    public type_vec: any;
    public x0: number;
    public x1: number;
    public y0: number;
    public y1: number;

    constructor(type_vec: any) {
        this.type_vec = type_vec;
        this.x0 = 0.0;
        this.y0 = 0.0;
        this.x1 = 0.0;
        this.y1 = 0.0;
    }

    set name(str) {
        this.#name = str;
    }

    get name() {
        return this.#name + this.type_vec.name;
    }

    get xlen() {
        return this.x1 - this.x0;
    }

    get ylen() {
        return this.y1 - this.y0;
    }

    get len() {
        return (this.xlen * this.xlen + this.ylen * this.ylen) ** 0.5;
    }

    get exist() {
        return this.len != 0.0;
    }

    get XCoordPointName() {
        return (this.x0 + this.type_vec.shiftpointname * this.xlen);
    }

    get YCoordPointName() {
        return (this.y0 + this.type_vec.shiftpointname * this.ylen);
    }/*Если ставить по центру, то будут наложения*/
    get AngleDegrees() {
        return (Math.atan2(this.ylen, this.xlen) * 180) / Math.PI;
    } /*Возвращает угол в градусах*/
    get TextPosition() {
        let angleGrad = this.AngleDegrees;
        if ((angleGrad >= -22.5) && (angleGrad < 22.5))
            return 'top center';
        else if ((angleGrad >= 22.5) && (angleGrad < 67.5))
            return 'top left';
        else if ((angleGrad >= 67.5) && (angleGrad < 112.5))
            return 'middle left';
        else if ((angleGrad >= 112.5) && (angleGrad < 157.5))
            return 'bottom left';
        else if (((angleGrad >= 157.5) && (angleGrad <= 180)) || ((angleGrad >= -180) && (angleGrad < -157.5)))
            return 'bottom center';
        else if ((angleGrad >= -157.5) && (angleGrad < -112.5))
            return 'bottom right';
        else if ((angleGrad >= -112.5) && (angleGrad < -67.5))
            return 'middle right';
        else
            return 'top right';
    }

    initVectorByPoints(
        x0: number | undefined,
        y0: number | undefined,
        x1: number | undefined,
        y1: number | undefined,
    ) {
        let x00: number;
        let y00: number;
        let x11: number;
        let y11: number;
        if (x0 === undefined) x00 = 0.0; else x00 = x0;
        if (y0 === undefined) y00 = 0.0; else y00 = y0;
        if (x1 === undefined) x11 = 0.0; else x11 = x1;
        if (y1 === undefined) y11 = 0.0; else y11 = y1;

        this.x0 = x00;
        this.y0 = y00;
        this.x1 = x11;
        this.y1 = y11;
    }

    initVectorByAngleGrad(
        vectorLen: number | undefined,
        degrees: number | undefined,
        xst: number | undefined,
        yst: number | undefined,
    ) {
        let vectorLen0: number;
        let radians: number;
        let xst0: number;
        let yst0: number;
        if (vectorLen === undefined) vectorLen0 = 0.0; else vectorLen0 = vectorLen;
        if (xst === undefined) xst0 = 0.0; else xst0 = xst;
        if (yst === undefined) yst0 = 0.0; else yst0 = yst;
        let x: number;
        let y: number;
        if (degrees === undefined) {
            radians = 0.0;
            x = 0.0;
            y = 0.0;
        } else {
            radians = degrees * Math.PI / 180;
            const precision = 1000;
            x = vectorLen0 * Math.round(Math.cos(radians) * precision) / precision;
            y = vectorLen0 * Math.round(Math.sin(radians) * precision) / precision;
        }

        this.x0 = xst0;
        this.y0 = xst0;
        this.x1 = x + this.x0;
        this.y1 = y + this.y0;
    };

    rotate(degrees: number): number[] {
        /*Вращение вектора вокруг точки*/
        let radians = degrees * Math.PI / 180;
        let x = this.xlen * Math.cos(radians) - this.ylen * Math.sin(radians);
        let y = this.xlen * Math.sin(radians) + this.ylen * Math.cos(radians);
        return [this.x0, this.y0, this.x0 + x, this.y0 + y];
    };

    shift(dx: number,
          dy: number) {
        this.x0 = this.x0 + dx
        this.y0 = this.y0 + dy
        this.x1 = this.x1 + dx
        this.y1 = this.y1 + dy
    };

}


export class GraphAll {
    vType: any;
    phA: GraphSingle;
    phB: GraphSingle;
    phC: GraphSingle;
    seqA1: GraphSingle;
    seqA2: GraphSingle;
    seqA0: GraphSingle;
    seqB1: GraphSingle;
    seqB2: GraphSingle;
    seqB0: GraphSingle;
    seqC1: GraphSingle;
    seqC2: GraphSingle;
    seqC0: GraphSingle;
    lineAB: GraphSingle;
    lineBC: GraphSingle;
    lineCA: GraphSingle;

    constructor(vType: any,
                showV0: boolean,
                a1: number[] | undefined,
                a2: number[] | undefined,
                a0: number[] | undefined) {
        this.vType = vType

        this.phA = new GraphSingle(VectorGraphParam.PhA);
        this.phB = new GraphSingle(VectorGraphParam.PhB);
        this.phC = new GraphSingle(VectorGraphParam.PhC);
        this.seqA1 = new GraphSingle(VectorGraphParam.SeqA1);
        this.seqA2 = new GraphSingle(VectorGraphParam.SeqA2);
        this.seqA0 = new GraphSingle(VectorGraphParam.SeqA0);
        this.seqB1 = new GraphSingle(VectorGraphParam.SeqB1);
        this.seqB2 = new GraphSingle(VectorGraphParam.SeqB2);
        this.seqB0 = new GraphSingle(VectorGraphParam.SeqB0);
        this.seqC1 = new GraphSingle(VectorGraphParam.SeqC1);
        this.seqC2 = new GraphSingle(VectorGraphParam.SeqC2);
        this.seqC0 = new GraphSingle(VectorGraphParam.SeqC0);
        this.lineAB = new GraphSingle(VectorGraphParam.LineAB);
        this.lineBC = new GraphSingle(VectorGraphParam.LineBC);
        this.lineCA = new GraphSingle(VectorGraphParam.LineCA);

        let vectors = this.vectors
        for (let i = 0; i < vectors.length; i++) {
            vectors[i].name = this.vType.name;

            let a10: number[];
            let a20: number[];
            let a00: number[];
            if (a1 === undefined) a10 = [0.0, 0.0, 0.0, 0.0]; else a10 = a1;
            if (a2 === undefined) a20 = [0.0, 0.0, 0.0, 0.0]; else a20 = a2;
            if (a0 === undefined) a00 = [0.0, 0.0, 0.0, 0.0]; else a00 = a0;
            /*Для корректной работы необходимо обязательно проинициализировать вектора последовательностей*/
            this.seqA1.initVectorByAngleGrad(a10[0], a10[1], a10[2], a10[3]);
            this.seqA2.initVectorByAngleGrad(a20[0], a20[1], a20[2], a10[3]);
            this.seqA0.initVectorByAngleGrad(a00[0], a00[1], a00[2], a00[3]);

            this.initCoordVectors(showV0);
        }
    }

    get vectors() {
        return [this.phA, this.phB, this.phC,
            this.seqA1, this.seqA2, this.seqA0,
            this.seqB1, this.seqB2, this.seqB0,
            this.seqC1, this.seqC2, this.seqC0,
            this.lineAB, this.lineBC, this.lineCA];
    }


    initCoordVectors(withzeroseq: boolean) {
        /*Расчёт координат векторов последовательностей*/
        let coord = this.seqA1.rotate(240);
        this.seqB1.initVectorByPoints(coord[0], coord[1], coord[2], coord[3]);
        coord = this.seqA1.rotate(120);
        this.seqC1.initVectorByPoints(coord[0], coord[1], coord[2], coord[3]);

        coord = this.seqA2.rotate(120);
        this.seqB2.initVectorByPoints(coord[0], coord[1], coord[2], coord[3]);
        coord = this.seqA2.rotate(240);
        this.seqC2.initVectorByPoints(coord[0], coord[1], coord[2], coord[3]);

        if (withzeroseq == true) {
            this.seqB0.initVectorByPoints(this.seqA0.x0, this.seqA0.y0, this.seqA0.x1, this.seqA0.y1);
            this.seqC0.initVectorByPoints(this.seqA0.x0, this.seqA0.y0, this.seqA0.x1, this.seqA0.y1);
        } else {
            /*Сбросим вектора нулевой последовательности, т.к. они не нужны
            Так делать можно, т.к. при перерисовке мы заново порождаем весь объект.
            */
            this.seqA0.initVectorByPoints(0.0, 0.0, 0.0, 0.0);
            this.seqB0.initVectorByPoints(0.0, 0.0, 0.0, 0.0);
            this.seqC0.initVectorByPoints(0.0, 0.0, 0.0, 0.0);
        }
        /*Расчет фазных векторов*/
        this.phA.x0 = 0.0;
        this.phA.y0 = 0.0;
        this.phB.x0 = 0.0;
        this.phB.y0 = 0.0;
        this.phC.x0 = 0.0;
        this.phC.y0 = 0.0;
        this.phA.x1 = this.seqA1.x1 + this.seqA2.x1 + this.seqA0.x1;
        this.phA.y1 = this.seqA1.y1 + this.seqA2.y1 + this.seqA0.y1;
        this.phB.x1 = this.seqB1.x1 + this.seqB2.x1 + this.seqB0.x1;
        this.phB.y1 = this.seqB1.y1 + this.seqB2.y1 + this.seqB0.y1;
        this.phC.x1 = this.seqC1.x1 + this.seqC2.x1 + this.seqC0.x1;
        this.phC.y1 = this.seqC1.y1 + this.seqC2.y1 + this.seqC0.y1;
        /*Сдвиг векторов*/
        this.seqA2.shift(this.seqA1.x1, this.seqA1.y1);
        this.seqB2.shift(this.seqB1.x1, this.seqB1.y1);
        this.seqC2.shift(this.seqC1.x1, this.seqC1.y1);

        this.seqA0.shift(this.seqA2.x1, this.seqA2.y1);
        this.seqB0.shift(this.seqB2.x1, this.seqB2.y1);
        this.seqC0.shift(this.seqC2.x1, this.seqC2.y1);
        /*Расчёт линейных векторов*/
        if (this.vType.showLine === true) {
            this.lineAB.initVectorByPoints(this.phB?.x1, this.phB?.y1, this.phA?.x1, this.phA?.y1);
            this.lineBC.initVectorByPoints(this.phC?.x1, this.phC?.y1, this.phB?.x1, this.phB?.y1);
            this.lineCA.initVectorByPoints(this.phA?.x1, this.phA?.y1, this.phC?.x1, this.phC?.y1);
        } else {
            this.lineAB.initVectorByPoints(0.0, 0.0, 0.0, 0.0);
            this.lineBC.initVectorByPoints(0.0, 0.0, 0.0, 0.0);
            this.lineCA.initVectorByPoints(0.0, 0.0, 0.0, 0.0);
        }
    }


}
